import { useMemo } from 'react';

import { ListType, LIST_TYPES } from 'constants/listTypes';

import {
  PaginatedSelectV2,
  BasePaginatedSelectV2Props,
  PaginatedSelectQueryV2Props,
  PaginatedDefaultV2Props,
  PaginatedSingleV2Props,
  PaginatedMultiV2Props,
  ParseMultipleItemsV2,
} from '../PaginatedSelect/PaginatedSelectV2';
import { List, fetchListsQuery, parseListsResponse } from './ListSelect.queries';

export const LIST_SELECT_PLACEHOLDER = {
  SINGLE: 'Select a List',
  MULTI: 'Select Lists',
};

export const DEFAULT_LIST_TYPES = [LIST_TYPES.DYNAMIC, LIST_TYPES.STANDARD, LIST_TYPES.INTERNAL];

export type FetchListParams = {
  listType?: ListType | ListType[];
  search?: string;
};

export const getListSelectFetchItemsVariables = ({
  listType = DEFAULT_LIST_TYPES,
  search,
}: FetchListParams = {}) => ({
  search,
  filterInfo: { listType },
});

export type ListSelectProps<TItem extends List = List> = BasePaginatedSelectV2Props &
  Partial<PaginatedSelectQueryV2Props<TItem>> &
  (PaginatedDefaultV2Props | PaginatedSingleV2Props | PaginatedMultiV2Props) & {
    /** The list types to show */
    listType?: ListType[];
  };

export function ListSelectV2<TItem extends List = List>({
  listType = DEFAULT_LIST_TYPES,
  ...props
}: ListSelectProps<TItem>) {
  const fetchVariables = useMemo(() => getListSelectFetchItemsVariables({ listType }), [listType]);

  return (
    <PaginatedSelectV2
      fetchAllItemsQuery={fetchListsQuery}
      fetchAllItemsVariables={fetchVariables}
      fetchAllItemsParser={parseListsResponse as ParseMultipleItemsV2<TItem>}
      placeholder={props?.isMulti ? LIST_SELECT_PLACEHOLDER.MULTI : LIST_SELECT_PLACEHOLDER.SINGLE}
      {...props}
    />
  );
}

export default ListSelectV2;
